import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  DonatePageSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  main: { marginTop: 12 },
  title: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '24px',
  },
  value: {
    fontSize: 14,
    fontFamily: 'Graphik',
    fontWeight: 500,
    lineHeight: '14px',
    marginBottom: 13,
  },
});
